import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuthStore } from "@app/auth/store";

interface RequireAuthProps {
  children: ReactNode;
}

/**
 * Gate that requires an authenticated session. Authorization itself is enforced
 * by the backend: `/admin/*` returns 403 for non-allowlisted users, and the axios
 * interceptor clears the session on 401/403 — so a rejected user lands back here
 * and is redirected to /login.
 */
export function RequireAuth({ children }: RequireAuthProps) {
  const token = useAuthStore((state) => state.token);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
